<template>
  <div class="talent-filter-group-list">
    <div class="default-group">
      <div class="default-group-title">{{ defaultGroup.name }}</div>
      <div class="chat-container">
        <div ref="reportChartDefault" class="default-group-chart"></div>
      </div>
      <div class="total">
        <span class="label">{{ $t('admin.talent.label.total') }}:</span>
        <span class="value">{{ defaultGroup.report.total_count|formatBigNumber }}</span>
      </div>
      <div class="default-report-items">
        <div class="default-group-item" v-for="(reportItem, index) in defaultGroup.report.items" :key="index">
          <div class="item-top">
            <div class="report-item-circle" :class="`circle-${reportItem.name.toLowerCase()}`"></div>
            <el-tooltip effect="light" popper-class="light-tooltip-popper" placement="bottom-start" :content="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)">
              <div class="name" @click="goToTalentPool(reportItem.name, defaultGroup.id)">{{reportItem.name}}</div>
            </el-tooltip>
          </div>
          <div class="report-item item-bottom">{{ reportItem.count|formatBigNumber }}</div>
        </div>
      </div>
      <div class="button-container" @click="handleView(defaultGroup)">
        {{ $t('admin.talent.label.groupFilterDetail') }}<i class="el-icon-arrow-right"/>
      </div>
    </div>
    <div class="user-group-tainer">
      <div class="search-conditions">
        <div class="search-condition-keyword">
          <el-select
            v-model="searchCondition.keyword"
            multiple
            filterable
            allow-create
            default-first-option
            clearable
            class="keywords-filter"
            :placeholder="$t('admin.crm.placeholder.talentFilterGroup.keywordSearch')"
            @change="handleKeywordsSelectChange"
          >
            <template #prefix><i class="el-icon-search"></i></template>
          </el-select>
          <!-- <el-input v-model="searchCondition.keyword" :placeholder="$t('admin.crm.placeholder.talentFilterGroup.keywordSearch')" @keyup.enter.native="handleSearchBtnClick">
            <el-button slot="append" icon="el-icon-search" @click="handleSearchBtnClick"></el-button>
          </el-input> -->
        </div>
        <div class="search-condition-right">
          <div class="search-condition-visibility">
            <el-select v-model="searchCondition.visibility" @change="handleVisibilityConditionChange" >
              <el-option
                v-for="(item, key) in visibilityType"
                :key="key"
                :label="$t(item.i18nKey)"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="search-condition-creator">
            <el-select  v-model="searchCondition.creator" @change="handleCreatorConditionChange" >
              <el-option
                v-for="(item, key) in creatorList"
                :key="key"
                :label="getCreatorLabel(item)"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="user-group-list">
        <div class="user-group" v-for="item in userGroupList" :key="item.id">
          <div class="user-group-parent">
            <div class="group-left">
              <div class="name-container">
                <div class="group-show-children" v-show="item.children && item.children.length > 0" @click="handleChangeGroupChildrenShow(item)"><i :class="item.showGroupChildren ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></div>
                <el-tooltip
                  effect="light"
                  popper-class="light-tooltip-popper"
                  :content="item.name"
                >
                  <div class="group-name name-overflow">{{ item.name }}</div>
                </el-tooltip>
                <div v-if="item.children" v-show="item.showGroupChildren" class="level-line"></div>
              </div>
              <div class="group-count" :class="item.children && item.children.length > 0 && 'has-children'">
                <div class="total-count">{{ item.report.total_count|formatBigNumber }}</div>
                <el-badge :value="(item.report.new_count < 0 ? '' : '+') + formatBigNumber(item.report.new_count)"></el-badge>
              </div>
            </div>
            <el-divider class="group-divider" direction="vertical"></el-divider>
            <div class="group-middle">
              <div :ref="`reportChart_${item.id}`" class="group-middle-left"></div>
              <div class="group-middle-right">
                <div class="group-middle-right-item" v-for="(reportItem, index2) in item.report.items" :key="index2">
                  <div class="report-item-circle" :class="`circle-${reportItem.name.toLowerCase()}`"></div>
                  <el-tooltip effect="light" popper-class="light-tooltip-popper" placement="bottom-start" :content="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)">
                    <div class="report-item report-item-name name-overflow" @click="goToTalentPool(reportItem.name, item.id)">{{reportItem.name}}</div>
                  </el-tooltip>
                  <div class="report-item">{{ reportItem.count|formatBigNumber }}</div>
                </div>
              </div>
            </div>
            <el-divider class="group-divider" direction="vertical"></el-divider>
            <div class="group-right">
              <div class="group-info">
                <div class="group-creator">
                  <span class="group-right-lable">{{ $t('admin.crm.label.talentFilterGroup.creator') }}:</span>
                  <span class="group-creator-name name-overflow">{{ item.creator.full_name }}</span>
                </div>
                <div class="group-private">
                  <span class="group-right-lable">{{ $t('admin.crm.label.talentFilterGroup.private') }}:</span>
                  <div class="group-visibility">
                    <el-switch
                      v-if="refreshSwitch"
                      v-model="item.isPrivate"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                      active-color="#0096cc"
                      @change="handleVisibilitySwitch(item)"
                      :width="switchWidth"
                      :disabled="item.creator.id != currentUser.id"
                      >
                    </el-switch>
                  </div>
                </div>
                <div v-if="item.creator.id == currentUser.id && item.isPrivate" class="group-assignment-labels">
                  <span class="label">{{ $t('admin.talent.label.groupAssign') }}</span>
                  <div class="group-assign-popover">
                    <AssignDialog
                      :canEdit="item.creator.id == currentUser.id"
                      :ownerInfo="item.owner_info"
                      :accountList="accountList"
                      :roleList="roleList"
                      @save="(info, callback) => handleAssignSave(item, info, callback)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="view-icon icon-pointer" @click="handleView(item)">
              {{ $t('admin.talent.label.groupFilterDetail') }}<i class="el-icon-arrow-right"/>
            </div>
            <div v-if="item.creator.id == currentUser.id" class="delete-icon icon-pointer" @click="handleDelete(item)"><i class="el-icon-delete"></i></div>
          </div>

          <template v-for="(child, childIndex) in item.children" >
            <div
              v-show="item.showGroupChildren"
              class="user-group-children"
              :key="child.id"
              :class="[
                childIndex === 0 && 'is-first',
                (childIndex === item.children.length - 1 && !child.showGroupChildren) && 'clear-white-line'
              ]"
              >
              <div class="group-left">
                <div class="name-container">
                  <div class="group-show-children" v-show="child.children && child.children.length > 0" @click="handleChangeGroupChildrenShow(child)"><i :class="child.showGroupChildren ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></div>
                  <el-tooltip
                  effect="light"
                  popper-class="light-tooltip-popper"
                  :content="child.name"
                  >
                    <div class="group-name name-overflow" :class="[(!child.children || child.children.length < 1) && 'no-children']">{{ child.name }}</div>
                  </el-tooltip>
                  <div v-if="childIndex === 0" class="level-line"></div>
                </div>
                <div class="group-count">
                  <div class="total-count">{{ child.report.total_count|formatBigNumber }}</div>
                  <el-badge :value="(child.report.new_count < 0 ? '' : '+') + formatBigNumber(child.report.new_count)"></el-badge>
                </div>
              </div>
              <el-divider class="group-divider" direction="vertical"></el-divider>
              <div class="group-middle">
                <div :ref="`childReportChart_${child.id}`" class="group-middle-left"></div>
                <div class="group-middle-right">
                  <div class="group-middle-right-item" v-for="(reportItem, index2) in child.report.items" :key="index2">
                    <div class="report-item-circle" :class="`circle-${reportItem.name.toLowerCase()}`"></div>
                    <el-tooltip effect="light" popper-class="light-tooltip-popper" placement="bottom-start" :content="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)">
                      <div class="report-item report-item-name name-overflow" :title="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)" @click="goToTalentPool(reportItem.name, child.id)">{{reportItem.name}}</div>
                    </el-tooltip>
                    <div class="report-item">{{ reportItem.count|formatBigNumber }}</div>
                  </div>
                </div>
              </div>
              <el-divider class="group-divider" direction="vertical"></el-divider>
              <div class="group-right">
                <div class="group-info">
                  <div class="group-creator">
                    <span class="group-right-lable">{{ $t('admin.crm.label.talentFilterGroup.creator') }}:</span>
                    <span class="group-creator-name name-overflow">{{ child.creator.full_name }}</span>
                  </div>
                  <div class="group-private">
                    <span class="group-right-lable">{{ $t('admin.crm.label.talentFilterGroup.private') }}:</span>
                    <div class="group-visibility">
                      <el-switch
                        v-if="refreshSwitch"
                        v-model="child.isPrivate"
                        :active-text="$t('common.yes')"
                        :inactive-text="$t('common.no')"
                        active-color="#0096cc"
                        @change="handleVisibilitySwitch(child)"
                        :width="switchWidth"
                        :disabled="child.creator.id != currentUser.id"
                        >
                      </el-switch>
                    </div>
                  </div>
                  <div v-if="child.creator.id == currentUser.id && child.isPrivate" class="group-assignment-labels">
                    <span class="label">{{ $t('admin.talent.label.groupAssign') }}</span>
                    <div class="group-assign-popover">
                      <AssignDialog
                        :canEdit="child.creator.id == currentUser.id"
                        :ownerInfo="child.owner_info"
                        :accountList="accountList"
                        :roleList="roleList"
                        @save="(info, callback) => handleAssignSave(child, info, callback)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="view-icon icon-pointer" @click="handleView(child)">
                {{ $t('admin.talent.label.groupFilterDetail') }}<i class="el-icon-arrow-right"/>
              </div>
              <div v-if="child.creator.id == currentUser.id" class="delete-icon icon-pointer" @click="handleDelete(child)"><i class="el-icon-delete"></i></div>
            </div>

            <div v-if="child.children" :key="childIndex" class="sub-child-container" :class="item.children.length -1 === childIndex && 'clear-line'">
              <div v-show="child.showGroupChildren" v-for="(subChild, subIndex) in child.children"  class="sub-children" :key="subChild.id" :class="subIndex === 0 && 'is-first'">
                <div class="group-left">
                  <div class="name-container">
                    <el-tooltip
                    effect="light"
                    popper-class="light-tooltip-popper"
                    :content="subChild.name"
                    >
                      <div class="group-name name-overflow">{{ subChild.name }}</div>
                    </el-tooltip>
                    <div v-if="child.children" v-show="child.showGroupChildren" class="level-line"></div>
                  </div>
                  <div class="group-count">
                    <div class="total-count">{{ subChild.report.total_count|formatBigNumber }}</div>
                    <el-badge :value="(subChild.report.new_count < 0 ? '' : '+') + formatBigNumber(subChild.report.new_count)"></el-badge>
                  </div>
                </div>
                <el-divider class="group-divider" direction="vertical"></el-divider>
                <div class="group-middle">
                  <div :ref="`childReportChart_${subChild.id}`" class="group-middle-left"></div>
                  <div class="group-middle-right">
                    <div class="group-middle-right-item" v-for="(reportItem, index2) in subChild.report.items" :key="index2">
                      <div class="report-item-circle" :class="`circle-${reportItem.name.toLowerCase()}`"></div>
                      <el-tooltip effect="light" popper-class="light-tooltip-popper" placement="bottom-start" :content="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)">
                        <div class="report-item report-item-name name-overflow" :title="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)" @click="goToTalentPool(reportItem.name, child.id)">{{reportItem.name}}</div>
                      </el-tooltip>
                      <div class="report-item">{{ reportItem.count|formatBigNumber }}</div>
                    </div>
                  </div>
                </div>
                <el-divider class="group-divider" direction="vertical"></el-divider>
                <div class="group-right">
                  <div class="group-info">
                    <div class="group-creator">
                      <span class="group-right-lable">{{ $t('admin.crm.label.talentFilterGroup.creator') }}:</span>
                      <span class="group-creator-name name-overflow">{{ subChild.creator.full_name }}</span>
                    </div>
                    <div class="group-private">
                      <span class="group-right-lable">{{ $t('admin.crm.label.talentFilterGroup.private') }}:</span>
                      <div class="group-visibility">
                        <el-switch
                          v-if="refreshSwitch"
                          v-model="subChild.isPrivate"
                          :active-text="$t('common.yes')"
                          :inactive-text="$t('common.no')"
                          active-color="#0096cc"
                          @change="handleVisibilitySwitch(subChild)"
                          :width="switchWidth"
                          :disabled="subChild.creator.id != currentUser.id"
                          >
                        </el-switch>
                      </div>
                    </div>
                    <div v-if="subChild.creator.id == currentUser.id && subChild.isPrivate" class="group-assignment-labels">
                      <span class="label">{{ $t('admin.talent.label.groupAssign') }}</span>
                      <div class="group-assign-popover">
                        <AssignDialog
                          :canEdit="subChild.creator.id == currentUser.id"
                          :ownerInfo="subChild.owner_info"
                          :accountList="accountList"
                          :roleList="roleList"
                          @save="(info, callback) => handleAssignSave(subChild, info, callback)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="view-icon icon-pointer" @click="handleView(subChild)">
                  {{ $t('admin.talent.label.groupFilterDetail') }}<i class="el-icon-arrow-right"/>
                </div>
                <div v-if="subChild.creator.id == currentUser.id" class="delete-icon icon-pointer" @click="handleDelete(subChild)"><i class="el-icon-delete"></i></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <ConfirmDialog
      class="confirm-delete-dialog"
      :title="$t('admin.talent.title.tip')"
      :show.sync="showDeleteDialog"
      :content="$t('admin.crm.message.talentFilterGroup.deleteConfirm')"
      @confirm="onDeleteOkBtnClick"
    >
    </ConfirmDialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VISIBILITY_TYPE } from '@/constant/crm'
import * as echarts from 'echarts'
import _ from 'lodash'
import { formatBigNumber } from '@/components/filters'
import ConfirmDialog from '@/components/dialog/confirmDialog.vue'
import AssignDialog from './dialog/assignDialog.vue'

window.echarts = echarts

const CHART_OPTION = {
  tooltip: {
    show: false,
    formatter: 'The report is in generating...'
  },
  dataset: {
  },
  angleAxis: {
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    axisTick: {
      show: false
    }
  },
  radiusAxis: {
    type: 'category',
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    axisTick: {
      show: false
    }
  },
  polar: {
    radius: ['30%', '80%']
  },
  series: [
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#ec7a3b'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#f1d45f'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#98cd95'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#b0dde2'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#6dadc8'
      },
      stack: 'a'
    }
  ],
  legend: {
  }
}

export default {
  components: {
    ConfirmDialog,
    AssignDialog
  },
  data () {
    return {
      formatBigNumber,
      refreshSwitch: true,
      showDeleteDialog: false,
      visibilityType: VISIBILITY_TYPE,
      searchCondition: {
        keyword: null,
        creator: 'all',
        visibility: 'all'
      },
      currentUser: {},
      defaultGroup: {
        name: '',
        report: {
          items: [
            {
              name: 'Hot',
              count: 0
            },
            {
              name: 'Active',
              count: 0
            },
            {
              name: 'Warm',
              count: 0
            },
            {
              name: 'Potential',
              count: 0
            },
            {
              name: 'Cold',
              count: 0
            }
          ]
        }
      },
      countNameOrder: ['Hot', 'Active', 'Warm', 'Potential', 'Cold'],
      activeItem: {
      },
      userGroupList: [],
      creatorList: [
        { id: 'all', name: 'allCreator' }
      ],
      accountList: [],
      roleList: []
    }
  },
  computed: {
    switchWidth () {
      if (this.$i18n.locale === 'en') {
        return 55
      } else {
        return 50
      }
    }
  },
  async created () {
    if (!this.hasAnyPermission('PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT')) {
      this.$router.push({ path: '/v-admin/talent-pool/-1' })
      return
    }
    this.$eventBus.$emit('showLoading', true)
    try {
      this.initSearchCondition()
      await Promise.all([
        this.getTalentFilterGroupList(),
        this.loadAccountList(),
        this.loadRoleList()
      ])
      this.currentUser = this.getCurrentAccount()
      const creatorIdList = { [this.currentUser.id]: this.currentUser.id }
      const creatorList = this.userGroupList.filter(item => {
        const creatorId = item.creator.id
        const hasProp = creatorIdList.hasOwnProperty(item.creator.id)
        if (!hasProp) {
          creatorIdList[creatorId] = creatorId
        }
        return !hasProp
      }).map(item => {
        return {
          id: item.creator.id,
          name: item.creator.full_name
        }
      })
      this.creatorList = this.creatorList.concat([{
        id: this.currentUser.id,
        name: 'my'
      }]).concat(creatorList)
      this.$nextTick(() => {
        this.initChart()
      })
    } finally {
      this.$eventBus.$emit('showLoading', false)
    }
  },
  methods: {
    ...mapActions('crm', ['changeTalentPoolSearchCondition']),
    ...mapActions('talent', ['searchTalentFilterGroup', 'updateTalentFilterGroupInfo', 'deleteTalentFilterGroup', 'updateTalentFilterGroup']),
    ...mapActions('company', ['getTeamMemberList']),
    ...mapActions('roleManagement', ['getRoleList']),
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapGetters('crm', ['getTalentPoolSearchCondition']),
    buildTree (list) {
      const indexedItems = _.keyBy(list, 'id')
      const rootItems = []

      _.forEach(list, item => {
        const parentId = item.parent_id
        if (parentId === null) {
          rootItems.push(item)
        } else {
          const parentItem = indexedItems[parentId]
          if (parentItem) {
            parentItem.children = parentItem.children || []
            parentItem.children.push(item)
          } else if (item.parents_ids?.length > 0) {
            let hasParent = false
            _.forEach(item.parents_ids, id => {
              const parentItem = indexedItems[id]
              if (parentItem) {
                hasParent = true
                parentItem.children = parentItem.children || []
                parentItem.children.push(item)
              }
            })

            if (!hasParent) {
              rootItems.push(item)
            }
          }
        }
      })

      return rootItems
    },
    async getTalentFilterGroupList () {
      const { keyword, creator, visibility } = this.searchCondition
      const params = {
        keyword: keyword?.join(','),
        creator,
        visibility
      }
      const resp = await this.searchTalentFilterGroup(params)
      if (resp) {
        const reportNameList = _.map(resp.default_group.report.items, 'name')
        this.countNameOrder = _.filter(this.countNameOrder, name => reportNameList.includes(name))
        _.forEach([resp.default_group, ...resp.user_groups], item => {
          const report = item.report
          report.items = _.map(this.countNameOrder, name => _.find(report.items, { name }))
        })
        this.defaultGroup = resp.default_group
        this.userGroupList = _.map(resp.user_groups, this.convertFilterGroup)
        const userGroupTree = this.buildTree(this.userGroupList)
        this.userGroupList = userGroupTree
      }
    },
    handleChangeGroupChildrenShow (item) {
      if (!item.showGroupChildren) {
        this.$set(item, 'showGroupChildren', false)
      }
      this.$set(item, 'showGroupChildren', !item.showGroupChildren)
      if (!item.showGroupChildren) {
        _.forEach(item.children, child => {
          this.$set(child, 'showGroupChildren', false)
        })
      }
      if (item.showGroupChildren) {
        this.initUserGroupChildrenChart(item)
      }
    },
    initChart () {
      this.initUserGroupChart()
      this.initDefaultGroupChart()
    },
    initSearchCondition () {
      const condition = this.getTalentPoolSearchCondition()
      if (condition.creator) {
        this.searchCondition.creator = condition.creator
      }
      if (condition.visibility) {
        this.searchCondition.visibility = condition.visibility
      }
    },
    initUserGroupChart () {
      this.userGroupList.forEach((item) => {
        const myChart = echarts.init(this.$refs[`reportChart_${item.id}`][0])
        const report = item.report
        let option
        if (!report.items.find(item => item.count !== 0)) {
          option = this.getInProgressChartOption(report, item.id)
        } else {
          option = this.getDoneChartOption(report, item.id)
        }
        myChart.setOption(option)
        this.initChartClickEvent(myChart)
      })
    },
    initUserGroupChildrenChart (item) {
      _.forEach(item.children, group => {
        const childChart = echarts.init(this.$refs[`childReportChart_${group.id}`][0])
        const childReport = group.report
        let childOption
        if (!childReport.items.find(group => group.count !== 0)) {
          childOption = this.getInProgressChartOption(childReport, group.id)
        } else {
          childOption = this.getDoneChartOption(childReport, group.id)
        }
        childChart.setOption(childOption)
        this.initChartClickEvent(childChart)
      })
    },
    initDefaultGroupChart () {
      const myChart = echarts.init(this.$refs.reportChartDefault)
      let option
      const report = this.defaultGroup.report
      if (!report.items.find(item => item.count !== 0)) {
        option = this.getInProgressChartOption(report, this.defaultGroup.id)
      } else {
        option = this.getDoneChartOption(report, this.defaultGroup.id)
      }
      myChart.setOption(option)
      this.initChartClickEvent(myChart)
    },
    initChartClickEvent (myChart) {
      myChart.on('click', (params) => {
        const nameArray = params.name.split('_')
        const activeness = nameArray[0]
        const talentFilterGroupId = nameArray[1]
        this.goToTalentPool(activeness, talentFilterGroupId)
      })
    },
    goToTalentPool (activeness, talentFilterGroupId) {
      if (activeness === 'Potential') {
        this.$router.push({ path: `/v-admin/talent-pool/${talentFilterGroupId}/potential/list` })
        return
      }
      this.$router.push({ path: `/v-admin/talent-pool/${talentFilterGroupId}`, query: { activenessType: activeness } })
    },
    getInProgressChartOption (report, talentFilterGroupId) {
      const option = JSON.parse(JSON.stringify(CHART_OPTION))
      option.dataset = {
        source: _.map(report.items, (reportItem, index) => {
          const dataItem = _.map(this.defaultGroup.report.items, item => 0)
          if (reportItem.name === 'Cold') {
            dataItem[index] = 100
          }
          const name = reportItem.name + '_' + talentFilterGroupId
          return [
            name,
            ...dataItem
          ]
        })
      }
      option.angleAxis.max = 100
      option.series[option.series.length - 1].itemStyle.color = '#dcdfe6'
      option.tooltip.show = true
      option.tooltip.formatter = (params, ticket, callback) => {
        return this.$t('admin.crm.tooltip.talentFilterGroup.generatingReport')
      }

      return option
    },
    getDoneChartOption (report, talentFilterGroupId) {
      const option = JSON.parse(JSON.stringify(CHART_OPTION))
      let maxCount = report.total_count
      const emptyCount = _.map(this.countNameOrder, _.constant(0))
      option.dataset = {
        source: _.map(report.items, (item, index) => {
          const name = item.name
          const count = item.count
          if (count > maxCount) {
            maxCount = count
          }
          const data = [`${name}_${talentFilterGroupId}`, ...emptyCount]
          data[index + 1] = count
          return data
        })
      }
      if (!this.countNameOrder.includes('Potential')) {
        option.series.splice(3, 1)
      }
      option.angleAxis.max = maxCount
      return option
    },
    convertFilterGroup (group) {
      const filterGroup = {
        ...group,
        isPrivate: !group.is_public,
        showGroupChildren: false
      }

      return filterGroup
    },
    getCreatorLabel (creator) {
      if (creator.name === 'allCreator') {
        return this.$t('admin.crm.option.talentFilterGroup.allCreator')
      } else if (creator.name === 'my') {
        return this.$t('admin.crm.option.talentFilterGroup.my')
      } else {
        return creator.name
      }
    },
    handleVisibilityConditionChange () {
      this.changeTalentPoolSearchCondition({ key: 'visibility', value: this.searchCondition.visibility })
      this.refreshUserGroupList()
    },
    handleCreatorConditionChange () {
      this.changeTalentPoolSearchCondition({ key: 'creator', value: this.searchCondition.creator })
      this.refreshUserGroupList()
    },
    handleKeywordsSelectChange () {
      this.refreshUserGroupList()
    },
    async refreshUserGroupList () {
      await this.getTalentFilterGroupList()
      this.$nextTick(() => {
        this.initChart()
      })
    },
    async handleVisibilitySwitch (group) {
      group.is_public = !group.isPrivate
      const groupDetail = group

      const children = groupDetail.children
      const childrenIds = []
      if (children?.length > 0) {
        _.forEach(children, item => {
          childrenIds.push(item.id)
          if (item.children?.length > 0) {
            _.forEach(item.children, subChild => {
              childrenIds.push(subChild.id)
            })
          }
        })
      }
      groupDetail.children_ids = childrenIds.join(',')

      await this.updateTalentFilterGroupInfo(groupDetail)
      this.refreshUserGroupList()
    },
    async handleDelete (group) {
      const children = group.children
      const childrenIds = []
      if (children?.length > 0) {
        _.forEach(children, item => {
          childrenIds.push(item.id)
          if (item.children?.length > 0) {
            _.forEach(item.children, subChild => {
              childrenIds.push(subChild.id)
            })
          }
        })
      }
      group.children_ids = childrenIds.join(',')
      this.activeItem = group
      this.showDeleteDialog = true
    },
    async onDeleteOkBtnClick () {
      const resp = await this.deleteTalentFilterGroup({
        id: this.activeItem.id,
        children_ids: this.activeItem.children_ids
      })
      if (resp) {
        this.$message({
          type: 'success',
          message: this.$t('admin.application.applicantList.message.deleteSuccess')
        })
      }
      this.refreshUserGroupList()
      this.showDeleteDialog = false
    },
    handleView (group) {
      this.$router.push({ path: `/v-admin/talent-pool/${group.id}` })
    },
    async handleAssignSave (group, ownerInfo, callback) {
      const params = {
        group_id: group.id,
        group_name: group.group_name,
        is_public: group.is_public,
        parent_group_id: group.parent_id,
        filters: group.filters,
        owner_info: ownerInfo
      }
      try {
        const resp = await this.updateTalentFilterGroup(params)
        if (resp) {
          this.$message.success(this.$t('admin.talent.message.assignSuccess'))
          await this.refreshUserGroupList()
        } else {
          this.$message.error(this.$t('admin.talent.message.assignFailed'))
        }
      } finally {
        callback()
      }
    },
    async loadAccountList () {
      const account = this.getCurrentAccount()
      const params = {
        companyId: account.root_company_id,
        is_all: true,
        exclude_disabled: true
      }
      const resp = await this.getTeamMemberList(params)
      if (resp) {
        this.accountList = _.orderBy(resp.results || [], [item => (item.name || '').toLowerCase()], ['asc'])
      }
    },
    async loadRoleList () {
      const resp = await this.getRoleList()
      if (resp) {
        this.roleList = _.map(resp.role_list || [], role => ({
          id: role.id,
          name: role.title
        }))
      }
    }
  },
  watch: {
    switchWidth (newValue, oldValue) {
      this.refreshSwitch = false
      this.$nextTick(() => {
        this.refreshSwitch = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.talent-filter-group-list {
  .default-group {
    margin-bottom: 10px;
    padding: 20px 24px;
    position: relative;
    display: flex;
    align-items: center;
    background-color: #fff;
    .default-group-title {
      color: #303133;
      font-size: 16px;
      font-weight: bold;
      height: 124px;
    }
    .chat-container {
      margin-left: auto;
    }
    .default-group-chart {
      width: 124px;
      height: 124px;
    }
    .total {
      margin-left: 60px;
      margin-right: 40px;
      .label {
        vertical-align: middle;
        color: #606266;
        font-size: 16px;
      }
      .value {
        vertical-align: middle;
        font-size: 24px;
        font-weight: bold;
        margin-left: 15px;
        color: #0096cc;
      }
    }
    .default-report-items {
      margin-right: auto;
      display: flex;
      align-items: center;
      .default-group-item {
        padding: 0 40px;
        position: relative;
        &::after {
          content: "";
          display: inline-block;
          width: 1px;
          height: 28px;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          position: absolute;
          background-color: #dcdfe6;
        }
        .item-top {
          display: flex;
          align-items: center;
          .name {
            margin-left: 16px;
            cursor: pointer;
          }
        }
        .item-bottom {
          text-align: center;
          margin-top: 10px;
        }
        .report-item {
          font-size: 16px;
        }
      }
    }

    .button-container {
      position: absolute;
      top: 20px;
      right: 24px;
      color: #909399;
      cursor: pointer;

      > i {
        margin-left: 10px;
      }
    }
  }
  .group-container {
    margin-top: 14px;
    padding: 20px 24px;
    background-color: #fff;

    .search-conditions {
      display: flex;
      justify-content: space-between;
      align-items: center;

      ::v-deep {
        .el-input--suffix .el-input__inner {
          color: #0096cc;
          border: none;
        }

        .el-icon-arrow-up::before {
          content: '\e78f';
        }
      }

      .search-condition-keyword {
        width: 350px;
        ::v-deep {
          .el-input__inner {
            height: 30px;
            line-height: 30px;
            border: 1px solid #b1b5bd;
          }

          .el-input__suffix {
            .el-icon-arrow-up {
              display: none;
            }
          }

          .el-input__prefix {
            height: 30px;
            line-height: 30px;
          }

          .el-select__input {
            margin-left: 20px;
          }
        }
      }
      .search-condition-right {
        display: flex;
        justify-content: flex-end;

        .search-condition-visibility {
          width: 73px;
        }

        .search-condition-creator {
          width: 114px;
        }

        ::v-deep .el-input__inner {
          color: #606266;
        }
      }
    }
  }
  .user-group-tainer {
    margin-top: 14px;
    padding: 20px 24px;
    background-color: #fff;
    .search-conditions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      ::v-deep {
        .el-input--suffix .el-input__inner {
          color: #0096cc;
          border: none;
        }
        .el-icon-arrow-up::before {
          content: '\e78f';
        }
      }
      .search-condition-keyword {
        width: 350px;
        ::v-deep {
          .el-input__inner {
            height: 30px;
            line-height: 30px;
            border: 1px solid #b1b5bd;
          }
          .el-input__suffix {
            .el-icon-arrow-up {
              display: none;
            }
          }
          .el-input__prefix {
            height: 30px;
            line-height: 30px;
          }
          .el-select__input {
            margin-left: 20px;
          }

          // .el-input-group--append {
          //   .el-input__inner {
          //     height: 30px;
          //     line-height: 30px;
          //     border: none;
          //   }
          //   .el-input-group__append {
          //     padding: 0 10px;
          //   }
          // }
        }
      }
      .search-condition-right {
        display: flex;
        justify-content: flex-end;
        .search-condition-visibility {
          width: 73px;
        }
        .search-condition-creator {
          width: 114px;
        }

        ::v-deep .el-input__inner {
          color: #606266;
        }
      }
    }
    .user-group-list {
      margin-top: 20px;
      .user-group {
        margin-bottom: 14px;
        // border: 1px solid #dcdfe6;

        .user-group-parent {
          background-color: #fafafa;
          border: 1px solid #dcdfe6;
          display: flex;
          align-items: center;
          height: 150px;
          position: relative;
          overflow: hidden;
          .group-left {
            width: 30%;
            height: 100%;
            padding-top: 40px;
            .name-container {
              padding-left: 20px;
              line-height: 22px;
              width: 300px;
              .group-name {
                display: inline-block;
                vertical-align: middle;
                font-size: 18px;
                font-weight: 500;
                line-height: 22px;
                color: #303133;
                max-width: 85%;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .group-show-children {
                margin-right: 20px;
                display: inline-block;
                vertical-align: middle;
                font-size: 18px;
                font-weight: bold;
                cursor: pointer;
                i {
                  color: #606266;
                }
              }
              .level-line {
                position: absolute;
                left: 28px;
                width: 1px;
                height: 100%;
                background-color: #c0c4cc;
              }
            }
            .group-count {
              display: flex;
              font-weight: bold;
              margin-top: 24px;
              margin-left: 20px;
              &.has-children {
                margin-left: 58px;
              }
              .total-count {
                font-size: 24px;
                color: #0096CC;
              }
              ::v-deep {
                .el-badge {
                  .el-badge__content {
                    background-color: #0096CC;
                    line-height: 14px;
                    height: 14px;
                    font-weight: lighter;
                    box-sizing: content-box;
                    position: absolute;
                    left: 0;
                    top: -10px;
                  }
                }
              }
            }
          }
          .group-divider {
            height: 80%;
            margin: 10px 10px 10px 5px;
          }
          .group-middle {
            flex: 0 32%;
            display: flex;
            align-items: center;
            margin: 0 5%;
            .group-middle-left {
              width: 125px;
              height: 125px;
              margin-right: 95px;
            }
            .group-middle-right {
              .group-middle-right-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
          .group-right {
            width: 30%;
            .group-info {
              margin-left: 100px;
              .group-creator {
                margin-bottom: 10px;
                .group-creator-name {
                  display: inline-block;
                  vertical-align: middle;
                  color: #8a8a8a;
                  margin-left: 10px;
                  font-size: 14px;
                  max-width: 130px;
                }
              }
              .group-private {
                display: flex;
                align-items: center;
              }
              .group-assignment-labels {
                display: flex;
                gap: 10px;
                margin: 8px 0;
                .label {
                  display: inline-block;
                  vertical-align: middle;
                  color: #d1d1d1;
                  font-size: 14px;
                  width: 60px;
                  text-align: right;
                }

                .group-assign-popover {
                  display: flex;
                  gap: 10px;
                  .assign-label {
                    display: inline-flex;
                    align-items: center;
                    cursor: pointer;

                    .label-text {
                      color: #0096cc;
                      font-size: 14px;
                    }
                  }
                }

              }
              .group-visibility {
                position: relative;
                margin-left: 10px;
                .el-switch {
                  ::v-deep {
                    .el-switch__label {
                      display: none;
                      position: absolute;
                      height: 100%;
                      color: #ffffff;
                      z-index: 1;
                      margin: 0;
                      &.is-active {
                        display: inline-block;
                      }
                    }
                    .el-switch__label--left {
                      left: 25px;
                    }
                    .el-switch__label--right {
                      left: 10px;
                    }
                  }
                }
              }
              .group-right-lable {
                display: inline-block;
                vertical-align: middle;
                color: #d1d1d1;
                font-size: 14px;
                width: 60px;
                text-align: right;
              }
            }
          }
          .view-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            color: #909399;
            > i {
              margin-left: 10px;
            }
          }
          .delete-icon {
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-size: 14px;
            color: #cacaca;
          }
        }

        .user-group-children {
          border-left: 1px solid #dcdfe6;
          border-right: 1px solid #dcdfe6;
          // margin-bottom: 20px;
          display: flex;
          align-items: center;
          height: 150px;
          position: relative;
          &::before {
            content: '';
            display: inline-block;
            height: 1px;
            width: 100%;
            background-color: #dcdfe6;
            position: absolute;
            bottom: 0;
            left: 0;
          }
          &::after {
            content: '';
            display: inline-block;
            height: 1px;
            width: 113px;
            background-color: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
          }
          &.clear-white-line {
            &::after {
              display: none;
            }
          }
          .group-left {
            width: 30%;
            height: 100%;
            padding-top: 40px;
            &::before {
              content: '';
              display: inline-block;
              height: 1px;
              width: 113px;
              background-color: #fff;
              position: absolute;
              top: -1px;
              left: 0;
            }
            .name-container {
              width: 300px;
              margin-left: 51px;
              line-height: 22px;
              &::before {
                content: '';
                position: absolute;
                top: -80px;
                left: 58px;
                display: inline-block;
                width: 1px;
                height: 115px;
                background-color: #c0c4cc;
              }
              .group-show-children {
                display: inline-block;
                vertical-align: middle;
                margin-right: 20px;
                font-size: 18px;
                cursor: pointer;
              }
              .group-name {
                display: inline-block;
                vertical-align: middle;
                font-size: 15px;
                line-height: 22px;
                color: #606266;
                font-weight: 500;
                max-width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .level-line {
                position: absolute;
                top: 0;
                left: 28px;
                width: 1px;
                height: 54px;
                background-color: #c0c4cc;
                z-index: 1;
              }
            }
            .group-count {
              display: flex;
              font-weight: bold;
              margin-top: 24px;
              margin-left: 109px;

              .total-count {
                font-size: 24px;
                color: #0096CC;
              }
              ::v-deep {
                .el-badge {
                  .el-badge__content {
                    background-color: #0096CC;
                    line-height: 14px;
                    height: 14px;
                    font-weight: lighter;
                    box-sizing: content-box;
                    position: absolute;
                    left: 0;
                    top: -10px;
                  }
                }
              }
            }
          }
          .group-divider {
            height: 80%;
            margin: 10px 10px 10px 5px;
          }
          .group-middle {
            flex: 0 32%;
            display: flex;
            align-items: center;
            margin: 0 5%;
            .group-middle-left {
              width: 125px;
              height: 125px;
              margin-right: 95px;
            }
            .group-middle-right {
              // margin-left: 30px;
              .group-middle-right-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
          .group-right {
            width: 30%;
            .group-info {
              margin-left: 100px;
              .group-creator {
                margin-bottom: 10px;
                .group-creator-name {
                  display: inline-block;
                  vertical-align: middle;
                  color: #8a8a8a;
                  margin-left: 10px;
                  font-size: 14px;
                  max-width: 130px;
                }
              }
              .group-private {
                display: flex;
                align-items: center;
              }
              .group-assignment-labels {
                display: flex;
                gap: 10px;
                margin: 8px 0;
                .label {
                  display: inline-block;
                  vertical-align: middle;
                  color: #d1d1d1;
                  font-size: 14px;
                  width: 60px;
                  text-align: right;
                }

                .group-assign-popover {
                  display: flex;
                  gap: 10px;
                  .assign-label {
                    display: inline-flex;
                    align-items: center;
                    cursor: pointer;

                    .label-text {
                      color: #0096cc;
                      font-size: 14px;
                    }
                  }
                }

              }
              .group-visibility {
                position: relative;
                margin-left: 10px;
                .el-switch {
                  ::v-deep {
                    .el-switch__label {
                      display: none;
                      position: absolute;
                      height: 100%;
                      color: #ffffff;
                      z-index: 1;
                      margin: 0;
                      &.is-active {
                        display: inline-block;
                      }
                    }
                    .el-switch__label--left {
                      left: 25px;
                    }
                    .el-switch__label--right {
                      left: 10px;
                    }
                  }
                }
              }
              .group-right-lable {
                display: inline-block;
                vertical-align: middle;
                color: #d1d1d1;
                font-size: 14px;
                width: 60px;
                text-align: right;
              }
            }
          }
          .view-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            color: #909399;
            > i {
              margin-left: 10px;
            }
          }
          .delete-icon {
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-size: 14px;
            color: #cacaca;
          }

          &.is-last {
            &::after {
              display: none;
            }
          }

          &.is-first {
            .group-left {
              &::before {
                display: none;
              }

              .name-container {
                margin-left: 28px;

                &::before {
                  display: none;
                }

                .group-show-children {
                  &::before {
                    content: '';
                    display: inline-block;
                    width: 10px;
                    height: 1px;
                    margin-right: 10px;
                    background-color: #c0c4cc;
                    vertical-align: middle;
                  }
                }

                .group-name {
                  &.no-children {
                    &::before {
                      content: '';
                      display: inline-block;
                      width: 10px;
                      height: 1px;
                      margin-right: 13px;
                      background-color: #c0c4cc;
                      vertical-align: middle;
                    }
                  }
                }
              }
            }
          }
        }

        .sub-child-container {
          position: relative;

          &::before {
            content: '';
            display: block;
            position: absolute;
            top: -80px;
            left: 59px;
            width: 1px;
            height: 100%;
            background-color: #c0c4cc;
            z-index: 1;
          }

          &.clear-line {
            &::before {
              display: none;
            }
          }

          .sub-children {
            border-left: 1px solid #dcdfe6;
            border-right: 1px solid #dcdfe6;
            display: flex;
            align-items: center;
            height: 150px;
            position: relative;
            &::before {
              content: '';
              display: inline-block;
              height: 1px;
              width: 100%;
              background-color: #dcdfe6;
              position: absolute;
              bottom: 0;
              left: 0;
            }
            &::after {
              content: '';
              display: inline-block;
              height: 1px;
              width: 113px;
              background-color: #fff;
              position: absolute;
              bottom: 0;
              left: 0;
            }
            .group-left {
              width: 30%;
              height: 100%;
              padding-top: 40px;
              overflow: hidden;
              .name-container {
                width: 100%;
                line-height: 20px;
                margin-left: 89px;
                .group-name {
                  display: inline-block;
                  vertical-align: middle;
                  font-size: 14px;
                  font-weight: 500;
                  line-height: 20px;
                  height: 20px;
                  color: #909399;
                  max-width: calc(100% - 90px);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  &::before {
                    display: none;
                    content: '';
                    display: inline-block;
                    width: 10px;
                    height: 1px;
                    margin-right: 18px;
                    background-color: #c0c4cc;
                    vertical-align: middle;
                  }
                }
                .level-line {
                  position: absolute;
                  top: -97px;
                  left: 88px;
                  width: 1px;
                  height: 100%;
                  background-color: #c0c4cc;
                  z-index: 1;
                }
              }
              .group-count {
                display: flex;
                font-weight: bold;
                margin-top: 24px;
                margin-left: 117px;

                .total-count {
                  font-size: 24px;
                  color: #0096CC;
                }
                ::v-deep {
                  .el-badge {
                    .el-badge__content {
                      background-color: #0096CC;
                      line-height: 14px;
                      height: 14px;
                      font-weight: lighter;
                      box-sizing: content-box;
                      position: absolute;
                      left: 0;
                      top: -10px;
                    }
                  }
                }
              }
            }
            .group-divider {
              height: 80%;
              margin: 10px 10px 10px 5px;
            }
            .group-middle {
              flex: 0 32%;
              display: flex;
              align-items: center;
              margin: 0 5%;
              .group-middle-left {
                width: 125px;
                height: 125px;
                margin-right: 95px;
              }
              .group-middle-right {
                .group-middle-right-item {
                  display: flex;
                  align-items: center;
                  margin-bottom: 10px;
                  &:last-child {
                    margin-bottom: 0;
                  }
                }
              }
            }
            .group-right {
              width: 30%;
              .group-info {
                margin-left: 100px;
                .group-creator {
                  margin-bottom: 10px;
                  .group-creator-name {
                    display: inline-block;
                    vertical-align: middle;
                    color: #8a8a8a;
                    margin-left: 10px;
                    font-size: 14px;
                    max-width: 130px;
                  }
                }
                .group-private {
                  display: flex;
                  align-items: center;
                }
                .group-assignment-labels {
                  display: flex;
                  gap: 10px;
                  margin: 8px 0;
                  .label {
                    display: inline-block;
                    vertical-align: middle;
                    color: #d1d1d1;
                    font-size: 14px;
                    width: 60px;
                    text-align: right;
                  }

                  .group-assign-popover {
                    display: flex;
                    gap: 10px;
                    .assign-label {
                      display: inline-flex;
                      align-items: center;
                      cursor: pointer;

                      .label-text {
                        color: #0096cc;
                        font-size: 14px;
                      }
                    }
                  }

                }
                .group-visibility {
                  position: relative;
                  margin-left: 10px;
                  .el-switch {
                    ::v-deep {
                      .el-switch__label {
                        display: none;
                        position: absolute;
                        height: 100%;
                        color: #ffffff;
                        z-index: 1;
                        margin: 0;
                        &.is-active {
                          display: inline-block;
                        }
                      }
                      .el-switch__label--left {
                        left: 25px;
                      }
                      .el-switch__label--right {
                        left: 10px;
                      }
                    }
                  }
                }
                .group-right-lable {
                  display: inline-block;
                  vertical-align: middle;
                  color: #d1d1d1;
                  font-size: 14px;
                  width: 60px;
                  text-align: right;
                }
              }
            }
            .view-icon {
              position: absolute;
              top: 10px;
              right: 10px;
              color: #909399;
              > i {
                margin-left: 10px;
              }
            }
            .delete-icon {
              position: absolute;
              bottom: 10px;
              right: 10px;
              font-size: 14px;
              color: #cacaca;
            }

            &:last-child {
              &::after {
                display: none;
              }
            }
            &.is-first {
              .group-left {
                .name-container {
                  .level-line {
                    top: -76px;
                    height: 129px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .report-item-circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .circle-hot {
    background-color: #ec7a3b;
  }
  .circle-active {
    background-color: #f1d45f;
  }
  .circle-warm {
    background-color: #98cd95;
  }
  .circle-potential {
    background-color: #b0dde2;
  }
  .circle-cold {
    background-color: #6dadc8;
  }
  .report-item {
    font-size: 12px;
  }
  .report-item-name {
    margin-left: 15px;
    width: 80px;
    cursor: pointer;
  }
  .name-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .icon-pointer {
    cursor: pointer;
  }
  .dialog-footer {
    .delete-btn {
      margin-left: 35px;
      float: left;
    }
  }
}
.page-en {
  .talent-filter-group-list {
    .user-group-tainer {
      .search-conditions {
        .search-condition-right {
          .search-condition-visibility {
            width: 90px;
          }
          .search-condition-creator {
            width: 165px;
          }
        }
      }
    }
  }
}
</style>
